var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPineapple = function SvgPineapple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pineapple_svg__a)",
    d: "M164.626 111.51A43.89 43.89 0 0 1 196 79.922a44 44 0 0 0-31.783 3.74A63.62 63.62 0 0 1 194.569 53a63.71 63.71 0 0 0-46.718 16.03c.067-.834.112-1.674.112-2.526A31.53 31.53 0 0 0 135 41a31.54 31.54 0 0 0-12.963 25.5c0 .852.045 1.692.112 2.526A63.7 63.7 0 0 0 75.431 53a63.62 63.62 0 0 1 30.352 30.664A44 44 0 0 0 74 79.922a43.89 43.89 0 0 1 31.374 31.588c-14.844 11.409-24.663 31.129-24.663 53.56 0 35.308 24.306 63.93 54.289 63.93s54.289-28.622 54.289-63.93c0-22.431-9.819-42.151-24.663-53.56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pineapple_svg__a",
    x1: 196.976,
    x2: 65.164,
    y1: 183.128,
    y2: 127.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgPineapple;